// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../log-in-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-a434857c]{color:#6b6b6b;font-size:13px;background-color:#f5f5f5;box-shadow:0 0 3.5px .5px #d6d1d1}.footer a[data-v-a434857c]{color:#6b6b6b;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
